import React from 'react';
import { componentsRedux } from 'redux/reusable';
import { useWeatherSubQuerys } from 'apollo/weather';

const Subqueries = (props) => {
  const { yearStart, yearEnd, weekStart, weekEnd } = props;
  const { data, loading } = useWeatherSubQuerys({
    yearStart,
    yearEnd,
    weekStart,
    weekEnd,
  });
  return <>{props.children({ loading, data: data.Subqueries })}</>;
};

export default componentsRedux(Subqueries);
